<template>
  <video ref="video">
    <source :src="currentSrc" />
  </video>
</template>

<script setup lang="ts">
import { useMounted } from "@vueuse/core";

const { src, srcMobile } = defineProps<{
  src: string;
  srcMobile?: string;
}>();

const { isDesktop } = useDevice();
const { lgAndUp } = useAppBreakpoints();
const isMounted = useMounted();
const video = ref<HTMLVideoElement | null>(null);

const currentSrc = computed(() => {
  const isDesktopDevice = isMounted.value ? lgAndUp.value : isDesktop;

  if (srcMobile && !isDesktopDevice) {
    return srcMobile;
  }

  return src;
});

watch(currentSrc, (newSrc, oldSrc) => {
  if (isMounted.value && newSrc !== oldSrc && video.value) {
    video.value.load();
    video.value.play();
  }
});
</script>
